import * as types from "./constants";

export const fetchOnboardingQueue = (residentId, callback, options = {}) => ({
  type: types.FETCH_ONBOARDING_QUEUE,
  payload: { residentId, silent: Boolean(options.silent) },
  callback,
});

export const fetchOnboardingQueueSuccess = (data) => ({
  type: types.FETCH_ONBOARDING_QUEUE_SUCCESS,
  payload: data,
});

export const fetchOnboardingQueueFailure = (error) => ({
  type: types.FETCH_ONBOARDING_QUEUE_FAILURE,
  payload: error,
});

export const dismissQueueItem = (
  residentId,
  templateId,
  reason,
  reasonText,
  callback,
) => ({
  type: types.DISMISS_QUEUE_ITEM,
  payload: { residentId, templateId, reason, reasonText },
  callback,
});

export const dismissQueueItemSuccess = (data) => ({
  type: types.DISMISS_QUEUE_ITEM_SUCCESS,
  payload: data,
});

export const dismissQueueItemFailure = (error) => ({
  type: types.DISMISS_QUEUE_ITEM_FAILURE,
  payload: error,
});

export const restoreQueueItem = (residentId, templateId, callback) => ({
  type: types.RESTORE_QUEUE_ITEM,
  payload: { residentId, templateId },
  callback,
});

export const restoreQueueItemSuccess = (data) => ({
  type: types.RESTORE_QUEUE_ITEM_SUCCESS,
  payload: data,
});

export const restoreQueueItemFailure = (error) => ({
  type: types.RESTORE_QUEUE_ITEM_FAILURE,
  payload: error,
});

export const fetchTemplateGovernance = (residentId, templateId, callback) => ({
  type: types.FETCH_TEMPLATE_GOVERNANCE,
  payload: { residentId, templateId },
  callback,
});

export const fetchTemplateGovernanceSuccess = (data) => ({
  type: types.FETCH_TEMPLATE_GOVERNANCE_SUCCESS,
  payload: data,
});

export const fetchTemplateGovernanceFailure = (error) => ({
  type: types.FETCH_TEMPLATE_GOVERNANCE_FAILURE,
  payload: error,
});

export const setCurrentTemplate = (templateId) => ({
  type: types.SET_CURRENT_TEMPLATE,
  payload: templateId,
});

export const resetBuilder = () => ({
  type: types.RESET_BUILDER,
});
